import React, {useState, useEffect} from 'react';
import './Cart.css';

import { ShoppingCart, X, Trash } from '@phosphor-icons/react';
import { useDetectClickOutside } from 'react-detect-click-outside';
import Loading from '../Loading/Loading';

import CartManager from './CartManager';
import ProductsManager from '../../pages/Shop/ProductsManager';
import config from '../../../../config';
import CheckoutCard from '../CheckoutCard/CheckoutCard';

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const Cart = (props) => {
    const [cartCount, setCartCount] = useState(0);
    const [displayCart, setDisplayCart] = useState(false);
    const [cartItems, setCartItems] = useState([]);
    const [cartPrice, setCartPrice] = useState(0);

    const ref = useDetectClickOutside({ onTriggered: () => setDisplayCart(false) });

    useEffect(() => {
        setCartCount(CartManager.getCartCount());
        if(displayCart){ 
            setCartCount(CartManager.getCartCount());
            CartManager.getCartItemsFull().then(items => {
                setCartItems(items);
            })
            if(CartManager.getCartCount() > 0) CartManager.getCartPrice().then(res => setCartPrice(res));
    
            //window.addEventListener("scroll", (e) => setDisplayCart(false));
            
            if(CartManager.getCartCount() !== null) {
                setCartCount(CartManager.getCartCount());
            }
        }    
        
        //window.addEventListener('storage', storageEventHandler, false);
    
        // async function storageEventHandler(e) {
        //     setCartCount(CartManager.getCartCount());
        //     setCartItems(await CartManager.getCartItemsFull());
        //     setCartPrice(await CartManager.getCartPrice());
        // }


    }, [displayCart]);

    async function toggleCart() {
        setDisplayCart(!displayCart);
        setCartCount(CartManager.getCartCount());
        setCartItems(await CartManager.getCartItemsFull());
        if(CartManager.getCartCount() > 0) setCartPrice(await CartManager.getCartPrice());
    }

    async function removeFromCart(product_id, quantity) {
        CartManager.removeFromCart(product_id, quantity).then(async items => {
            setCartCount(CartManager.getCartCount());
            setCartItems(await CartManager.getCartItemsFull());
        })
        setCartPrice(await CartManager.getCartPrice());
    }

    return (
        <div className='cart-container' ref={ref}>
            {
                cartCount > 0 &&
                <div className="CartCount">{cartCount}</div>
            }
            
            <a href="#!" className='Button' onClick={()=>{toggleCart()}}>
                <div className='d-flex justify-center align-center' style={{height: "100%", width: "100%"}}>
                    <img  src="/assets/img/cart.svg" style={{height: "1em", width: "1em"}} alt={`${config.brand_name}  Cart`} />
                </div>
            </a>
            {/*    <ShoppingCart className='CartButton' size={props.mobile ? 30 : 30} onClick={()=>{toggleCart()}} /> */}
            
            {
                displayCart &&
                <div>
                    <div className="CartDisplay bg-light shadow desktop">
                        <div className="w-100 d-flex space-between">
                            <h4 className='no-block-start'>Your Cart</h4>
                        <X size={20} className="CartClose pointer" onClick={()=>setDisplayCart(false)} /></div>
                        {
                            cartCount == 0 && cartItems &&
                            <div className="CartEmpty mb-2 d-flex col align-center">
                                <p className='no-block-start'>There's nothing in your cart yet.</p>
                                <a href="/">
                                    <button className="Button">Shop Now</button>
                                </a>
                            </div>
                        }
                        {
                            cartItems ?
                            (cartCount > 0) &&
                            <>
                                <div className="CartItems">
                                    <div>
                                        {
                                            cartItems != [] ?
                                            <div>
                                                {
                                                    cartItems.sort((a,b) => {
                                                        return a > b ? -1 : 1;
                                                    }).map((item, index) => {
                                                        return (
                                                            <div>
                                                                <CheckoutCard item={item} removeFromCart={removeFromCart} className="bg-light"></CheckoutCard>
                                                                <br /><br />
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            :                                    
                                            <Loading/>
                                        }
                                    </div>
                                </div>
                                <div className='CartBottom'>
                                    <div className='CartBottomFade'></div>
                                    <div className='CartBottomInner'>
                                        <div>
                                            <b>Cart Total: ${numberWithCommas((cartPrice * 1.1).toFixed(2))}</b>
                                        </div>
                                        <br />
                                        <div className='d-flex'>
                                            <button className="Button flex-5" onClick={()=>window.location.href = "/checkout"}>Checkout</button>
                                            <div className="flex-1"></div>
                                            <button className="Button flex-5 grayscale" onClick={()=>{CartManager.clearCart(); setCartCount(0)}}>Clear cart</button>
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            <Loading/>
                        }
                    </div>
                    <div className="MobileCartDisplay bg-light shadowBottom mobile">
                        <div className="w-100 d-flex space-between">
                            <h4 className='no-block-start'>Your Cart</h4>
                        <X size={20} className="CartClose pointer" onClick={()=>setDisplayCart(false)} /></div>
                        {
                            cartCount == 0 && cartItems &&
                            <div className="CartEmpty mb-2 d-flex col align-cente">
                                <p className='no-block-start'>There's nothing in your cart yet.</p>
                                <a href="/">
                                    <button className="Button">Shop Now</button>
                                </a>
                            </div>
                        }
                        {
                            cartItems ?
                            (cartCount > 0) &&
                            <div className="CartItems">
                                <div>
                                    {
                                        cartItems != [] ?
                                        <div>
                                            {
                                                cartItems.sort((a,b) => {
                                                    return a > b ? -1 : 1;
                                                }).map((item, index) => {
                                                    return (
                                                        <div>
                                                            <CheckoutCard item={item} removeFromCart={removeFromCart} className="bg-light"></CheckoutCard>
                                                            <br /><br />
                                                        </div>
                                                    )
                                                })
                                            }
                                            <div>
                                                <b>Cart Total: ${numberWithCommas((cartPrice * 1.1).toFixed(2))}</b>
                                            </div>
                                        </div>
                                        :                                    
                                        <Loading/>
                                    }
                                </div>
                                <br />
                                <div className='d-flex'>
                                    <button className="Button flex-5" onClick={()=>window.location.href = "/checkout"}>Checkout</button>
                                    <div className="flex-1"></div>
                                    <button className="Button flex-5 grayscale" onClick={()=>{CartManager.clearCart(); setCartCount(0)}}>Clear cart</button>
                                </div>
                            </div>
                            :
                            <Loading/>
                        }
                    </div>
                </div>
                
            }
        </div>
    );
};

export default Cart;